exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-group[data-v-341cc0ce]{width:100%;display:flex;justify-content:flex-end}.button-group button[data-v-341cc0ce]:last-of-type{margin-left:1rem}", ""]);

// exports
